<template>
  <div class="net-item-value-plain">
    <slot name="value">
      <span v-if="value == null" class="net-item-value-plain__value">?</span>
      <span v-else :title="formatNumber(value, { maximumFractionDigits: 5 })" class="net-item-value-plain__value">
        <template v-if="value == null">
          {{ formatNumber(value, { maximumFractionDigits: maxDecimalPoints }) }}
        </template>
        <template v-else>
          <AnimatedNumber :value="Number(value)" :max-decimal-points="maxDecimalPoints"></AnimatedNumber>
        </template>
      </span>
    </slot>
    <slot name="unit">
      <span class="net-item-value-plain__unit">{{ unit }}</span>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { formatNumber } from "@/helpers/utility/Formatting";
import AnimatedNumber from "@core/wrappers/AnimatedNumber.vue";

withDefaults(defineProps<{
  value: number | boolean | undefined | null;
  unit?: string;
  maxDecimalPoints?: number;
}>(), {
  maxDecimalPoints: 3
});
</script>

<style lang="scss">
.net-item-value-plain {
  display: block;
  white-space: nowrap;
  flex-shrink: 0;
  position: relative;

  font-weight: 700;
  font-size: 1.25em;

  &__value {
    padding-right: 0.125em;
  }

  &__unit {
    display: inline-grid !important;
    font-weight: 400;
    min-width: 0.5em;
    font-size: 0.9em;
    line-height: 1em;
  }
}
</style>
